// extracted by mini-css-extract-plugin
export default {"root":"Toggle_root__tbIbo"};